const SUPPORTED_MIME_TYPES = [
  "image/*",
  "audio/*",
  "video/*",
  "text/plain",
  "text/markdown",
  "text/html",
  "text/csv",
  "application/json",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.fabric.notepad",
  "application/vnd.fabric.bookmark",
  "application/vnd.fabric.highlight"
];
const getIsResourceMimeTypeSupportedByAssistant = (mimeType) => {
  if (!mimeType) return false;
  return SUPPORTED_MIME_TYPES.some((supportedType) => {
    if (supportedType.endsWith("/*")) {
      const supportedPrefix = supportedType.split("/*")[0];
      return mimeType.startsWith(supportedPrefix);
    }
    return mimeType === supportedType;
  });
};

export { getIsResourceMimeTypeSupportedByAssistant };
//# sourceMappingURL=getIsResourceMimeTypeSupportedByAssistant.js.map
